import { inject, Injectable, signal } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from '../config/auth.config';
import { Router } from '@angular/router';
import {jwtDecode} from 'jwt-decode';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

    private oauthService: OAuthService = inject(OAuthService);
    private router: Router = inject(Router);

    public hasSession = signal(false);
    
    async initAuth(): Promise<void> {
      this.oauthService.configure(authConfig);
      try {

        // Methods loadDiscoveryDocument() and tryLogin() can be replaced with method loadDiscoveryDocumentAndTryLogin instead.

        // await this.oauthService.loadDiscoveryDocument();
        // const loggedIn = await this.oauthService.tryLogin();

        await this.oauthService.loadDiscoveryDocumentAndTryLogin();

        if (this.oauthService.hasValidAccessToken()) {
          console.log('User is authenticated.');
          // console.log('idToken', this.oauthService.getIdToken());
          this.hasSession.set(true);
          const userId = this.setUserId(this.oauthService.getAccessToken());
          window.sessionStorage.setItem('user_id', userId);
          // console.log(this.oauthService.getAccessToken());
          // console.log(this.oauthService.getRefreshToken());
          // console.log('getIdToken => ', this.oauthService.getIdToken());
          // console.log(this.oauthService.getAccessTokenExpiration);
          // console.log(this.oauthService.getGrantedScopes);
          if(window.location.pathname.includes("/callback")) {
            this.router.navigate(["/"])
          }
        } else {
          console.log('User is not authenticated.');
          console.log('Redirect URi => ', `${window.location.origin}`);
          this.hasSession.set(false);
          this.login();
        }
      } catch (err) {
        console.log('loadDiscoveryDocument => ', err);
      }

    }

    login() {
        this.oauthService.initCodeFlow();
    }

    logout(token: any) {
      sessionStorage.clear();
      localStorage.clear();
      // ToDo: do we need this code here?
      // Redirect to PingFederate logout endpoint
      this.oauthService.logOut();
      const relayState = encodeURIComponent(window.location.origin); // Redirect back to home page after logout
      const logoutUrl = `https://openam-day1cloud-use1-sandbox.id.forgerock.io/am/oauth2/alpha/connect/endSession?id_token_hint=${token}&post_logout_redirect_uri=${window.location.origin}`
      console.log('logout => ', token);
      console.log('logoutUrl => ', logoutUrl);
      console.log('Redirect URi => ', `${window.location.origin}`);
      window.location.href = logoutUrl;
    }

    get isLogedIn() {
      return this.oauthService.hasValidAccessToken();
    }

    get IdToken() {
      return this.oauthService.getIdToken();
    }

    get userProfile() {
      return this.oauthService.getIdentityClaims() ?? {};
    }

    /**
     * Temporary method to get the userId from decoded JWT
     * Todo: Improve validations...
     * @param token 
     * @returns userId as string
     */
    private setUserId(token: any):string {
      const obj = jwtDecode(token);
      const { sub } = obj;
      return sub as string;
    }
}
